"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SDK_VERSION = "1.0.4";
var MODAL_MODES = {
  WITHOUT_CLOSE_BUTTON: 1,
  WITH_CLOSE_BUTTON: 2
};

var BerbixVerify = /*#__PURE__*/function (_React$Component) {
  _inherits(BerbixVerify, _React$Component);

  var _super = _createSuper(BerbixVerify);

  function BerbixVerify(props) {
    var _this;

    _classCallCheck(this, BerbixVerify);

    _this = _super.call(this, props);
    _this.state = {
      height: 0,
      marginTop: 0,
      idx: 0,
      show: true
    };
    _this.handleMessage = _this.handleMessage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BerbixVerify, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== "undefined") {
        window.addEventListener("message", this.handleMessage);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== "undefined") {
        window.removeEventListener("message", this.handleMessage);
      }
    }
  }, {
    key: "parseMessage",
    value: function parseMessage(data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        // Could not parse message, discarding as it's likely coming from extension or other source
        return null;
      }
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(e) {
      var _this$props = this.props,
          onComplete = _this$props.onComplete,
          onError = _this$props.onError,
          onDisplay = _this$props.onDisplay,
          onStateChange = _this$props.onStateChange,
          onCloseModal = _this$props.onCloseModal;

      if (e.origin !== this.baseUrl()) {
        return;
      }

      var data = this.parseMessage(e.data);

      if (data === null) {
        // The message couldn't be parsed, so we skip this step
        return;
      }

      if (data.type === "VERIFICATION_COMPLETE") {
        try {
          if (data.payload.success) {
            onComplete();
          } else {
            onError(data);
          }
        } catch (e) {// Continue clean-up even if callback throws
        }

        this.setState({
          show: false
        });
      } else if (data.type === "DISPLAY_IFRAME") {
        onDisplay();
        this.setState({
          height: data.payload.height,
          marginTop: data.payload.margin || 0
        });
      } else if (data.type === "RESIZE_IFRAME") {
        this.setState({
          height: data.payload.height
        });
      } else if (data.type === "RELOAD_IFRAME") {
        this.setState({
          height: 0,
          idx: this.state.idx + 1
        });
      } else if (data.type === "STATE_CHANGE") {
        onStateChange(data.payload);
      } else if (data.type === "EXIT_MODAL") {
        onCloseModal();
      } else if (data.type === "ERROR_RENDERED") {
        onError(data.payload);
        this.setState({
          height: 200
        });
      }
    }
  }, {
    key: "baseUrl",
    value: function baseUrl() {
      var baseUrl = this.props.baseUrl;

      if (baseUrl != null) {
        return baseUrl;
      }

      return "https://verify.berbix.com";
    }
  }, {
    key: "frameUrl",
    value: function frameUrl() {
      var _this$props2 = this.props,
          overrideUrl = _this$props2.overrideUrl,
          version = _this$props2.version,
          clientToken = _this$props2.clientToken,
          showInModal = _this$props2.showInModal,
          showCloseModalButton = _this$props2.showCloseModalButton;

      if (overrideUrl != null) {
        return overrideUrl;
      }

      var options = ["sdk=BerbixReact-".concat(SDK_VERSION)];

      if (clientToken) {
        options.push("client_token=".concat(clientToken));
      }

      if (showInModal) {
        var modalMode = showCloseModalButton ? MODAL_MODES.WITH_CLOSE_BUTTON : MODAL_MODES.WITHOUT_CLOSE_BUTTON;
        options.push("modal=".concat(modalMode));
      }

      var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      options.push("max_height=".concat(height));
      return this.baseUrl() + "/" + version + "/verify?" + options.join("&");
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.show) {
        return null;
      }

      var iframe = /*#__PURE__*/React.createElement("iframe", {
        title: "Berbix ID Verification",
        key: this.state.idx,
        src: this.frameUrl(),
        style: {
          backgroundColor: "transparent",
          border: "0 none transparent",
          padding: 0,
          margin: 0,
          display: "block",
          width: "100%",
          height: this.state.height + "px",
          overflow: "hidden"
        },
        allow: "camera",
        scrolling: "no",
        referrerPolicy: "no-referrer-when-downgrade"
      });

      if (this.props.showInModal) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            width: "100%",
            height: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1000
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            margin: "0 auto",
            width: "100%",
            maxWidth: "500px",
            maxHeight: "100%",
            overflow: "auto",
            marginTop: this.state.marginTop + "px"
          }
        }, iframe));
      }

      return iframe;
    }
  }]);

  return BerbixVerify;
}(React.Component);

BerbixVerify.propTypes = {
  // Required
  clientToken: _propTypes["default"].string,
  // Configurations
  showInModal: _propTypes["default"].bool,
  showCloseModalButton: _propTypes["default"].bool,
  // Event handlers
  onComplete: _propTypes["default"].func.isRequired,
  onError: _propTypes["default"].func,
  onDisplay: _propTypes["default"].func,
  onCloseModal: _propTypes["default"].func,
  // Deprecated
  onStateChange: _propTypes["default"].func,
  // Internal use
  baseUrl: _propTypes["default"].string,
  overrideUrl: _propTypes["default"].string,
  version: _propTypes["default"].string
};
BerbixVerify.defaultProps = {
  onError: function onError() {},
  onDisplay: function onDisplay() {},
  onStateChange: function onStateChange() {},
  onCloseModal: function onCloseModal() {},
  version: "v0"
};
var _default = BerbixVerify;
exports["default"] = _default;